/**
 * Sets the state of the first ancestor details element to open.
 */
function openAncestorDetails(element: HTMLElement | null) {
	if (element === null) {
		return;
	}
	const details = element.closest("details");
	if (details !== null) {
		details.open = true;
	}
}

/*
 * Presents a form field by scrolling it into view.
 * Optionally focuses the input if `focus` argument is true.
 */
export function showFormField(inputId: string, focus = false) {
	const element = document.getElementById(inputId);
	openAncestorDetails(element);
	element?.scrollIntoView({ behavior: "smooth" });
	if (focus) {
		element?.focus();
	}
}
